/**
 * 全局混入埋点操作
 */
import { saveTrack } from "@/http/api";

export default {
    beforeCreate() {
        // 正则方式匹配名字前缀为cashier_的组件才会被埋点
        if (!/^cashier_/.test(this.$options.name)) return;

        this.startAt = performance.now();
    },
    mounted() {
        if (!/^cashier_/.test(this.$options.name)) return;

        this.$track('初始化页面', {
            loadTime: (performance.now() - this.startAt).toFixed() + 'ms',
        });
    },
    methods: {
        $track(eventName, data) {
            let now = performance.now();
            if (this.newUpdataAt == undefined) {
                this.newUpdataAt = now;
            }
            let tsl = ((now - this.newUpdataAt) * 0.001).toFixed(3) + 's';

            let params = {
                // 事件名
                event_name: eventName,
                // 组件名
                component_name: this.$options.name,
                host: window.location.host,
                // 来源
                referrer: document.referrer,
                // 浏览器信息
                browser_info: window.navigator.userAgent,
                // 平台订单号
                platform_order_no: this.$route.query.pay_id,
                // 与前一次操作相隔时间
                time_since_last_operation: tsl,
                // 扩展字段
                ext_info: {...data},
            };
            saveTrack(params);
            this.newUpdataAt = performance.now();
        }
    }
};
